export const trans = function(value, params = {}) {
  return Translator.trans(value, params);
}

export const transLocale = function() {
  return Translator.locale;
}
